
export default {
  name: "CTA",
  props: {
    translation: String,
    path: String
  }
}
